import { Box, Paper, Typography } from "@mui/material";
import React from "react";

const GridCards = ({ data, cardWidth, gap, cardPadding }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: gap || { xs: "10px", sm: "20px" },
        "& > :not(style)": {
          m: 1,
          width: cardWidth || { xs: "100%", sm: "47%", md: 400 },
          height: "auto",
        },
      }}
    >
      {data.map((item, index) => (
        <Paper
          key={index}
          elevation={3}
          sx={{
            borderRadius: "5%",
            textAlign: "center",
            padding: cardPadding || "3%",
            alignContent: "center",
          }}
        >
          {item.src && (
            <img
              src={item.src}
              alt={item.alt || ""}
              loading="lazy"
              style={{
                boxSizing: "border-box",
                width: item.imgWidth || "100%",
                height: "auto",
                paddingTop: item.paddingTop || "0",
              }}
            />
          )}

          {item.title && (
            <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: "700",
              fontSize: { xs: "14px", sm: "16px" },
              lineHeight: "21px",
              textAlign: "center",
              color: "#000000",
              paddingTop: "5%",
              whiteSpace: "pre-line", // 👈 This handles line breaks
            }}
          >
            {item.title}
          </Typography>
          )}
          {item.description && (
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: "400",
                          fontSize: { xs: "8px", md: "14px" },
                          textAlign: "center",
                          padding: "4% 6% 1% 6%",
                          color: "#555555",
                        }}
                      >
                        {item.description}
                      </Typography>
                    )}
        </Paper>
      ))}
    </Box>
  );
};

export default GridCards;
